var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUy = function SvgUy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9d78c86e-bbdc-4c0e-9f83-8b67c0d1debea)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "14dc2838-e929-47e6-a45c-b46a4d90db15b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#14dc2838-e929-47e6-a45c-b46a4d90db15b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005CB2",
    fillRule: "evenodd",
    d: "M10 3h11v2H10zm0 4h11v2H10zM0 11h21v2H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEA7B",
    fillRule: "evenodd",
    d: "M6.88 6.88C6.65 8.125 6.12 9 5.5 9s-1.15-.874-1.38-2.12C2.875 6.65 2 6.12 2 5.5s.874-1.15 2.12-1.38C4.35 2.875 4.88 2 5.5 2s1.15.874 1.38 2.12C8.125 4.35 9 4.88 9 5.5s-.874 1.15-2.12 1.38",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCD715",
    fillRule: "evenodd",
    d: "M6.187 6.187C6.123 7.79 5.84 9 5.5 9s-.623-1.21-.687-2.813C3.21 6.123 2 5.84 2 5.5s1.21-.623 2.813-.687C4.877 3.21 5.16 2 5.5 2s.623 1.21.687 2.813C7.79 4.877 9 5.16 9 5.5s-1.21.623-2.813.687",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCD715",
    d: "M5.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9d78c86e-bbdc-4c0e-9f83-8b67c0d1debea"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgUy;